module.exports = __webpack_public_path__ + "static/media/ssgandhy.f589779b.png";